import { PagesizeType } from '../../service/pagination/pagesize-type';
import { Component, OnInit, ViewChild } from '@angular/core';
import { OnyxEvent } from '../../models/event';
import { EventStore } from '../../service/event.store';
import { TransientTableComponent } from '../transient-table/transient-table.component';
import { TransientSearchComponent } from '../transient-search/transient-search.component';
import { TransientReservationStore } from '../../service/transient-reservation-store';
import { MenuStore } from '../../../menus/service/menu.store';
import { TransientReservation } from '../../models/reservation';
import { Page } from '../../../shared/models/page';

@Component({
  selector: 'pioneer-transient-reservation',
  templateUrl: './transient-reservation.component.html'
})
export class TransientReservationComponent implements OnInit {

  public onyxEvent: OnyxEvent;

  @ViewChild(TransientTableComponent)
  public transientTableComponent: TransientTableComponent;

  @ViewChild(TransientSearchComponent)
  public transientSearchComponent: TransientSearchComponent;

  public hasSearched: boolean;

  public searchResults: Page<TransientReservation>;

  pagesizeType = PagesizeType.TRANSIENT_RESERVATIONS;

  constructor(private eventStore: EventStore,
              private transientReservationStore: TransientReservationStore,
              private menuStore: MenuStore) { }

  ngOnInit() {
    this.eventStore.selectedEvent.subscribe(ev => this.onyxEvent = ev);

    this.hasSearched = false;

    if (this.onyxEvent) {
      this.menuStore.setPageHeader(this.onyxEvent.name, this.onyxEvent.eventProperty.subscriber);
    } else {
      throw new Error('The "event" attribute must be specified to use the TransientReservationComponent component');
    }

  }

  onHasSearched() {
    this.hasSearched = true;

    const obs$ = this.transientReservationStore.searchResults.take(1);

    obs$.subscribe((page: Page<TransientReservation>) => {
      this.searchResults = page;
    });

  }

  onRefreshList(page: number) {
    this.transientSearchComponent.refreshTransientReservations(page);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/reservations/transient-reservation/transient-reservation.component.ts